<template lang="html">
   <v-container wrap style="padding:  0px !important; margin: 0px;">
  <v-layout row wrap style="background-color: none !important;">
    <v-flex xs12 class="setBgHeaderRegis widthfull"  :style="{background: backgroundText}">
      <v-layout align-center justify-center row wrap style="height: 30px;">
        <v-flex xs12>
          <v-layout align-center justify-center row wrap>
            <h3 class="centerDiv mt-1" style="color: white">แชทกับเจ้าหน้าที่ OSS</h3>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="setHeightChatBoxRegis" style=" height: 100vh;">
      <div style="background: white !important; height: 100vh;">
<!--       <v-layout row wrap align-center justify-start style="padding-left: 16px; padding-right: 16px; padding-top: 10px; padding-bottom: 10px;">
        <v-flex xs6>

        <h4>ข้อมูลส่วนตัว</h4>
        </v-flex>
      </v-layout> -->
      <v-layout column wrap align-center justify-start style="padding-left: 10px; padding-right: 10px; padding-bottom: 10px;">
        <v-form v-model="valid" ref="form" style="width: 100% !important;" v-if="typelogin == ''">
          <h4 style="margin: 20px 0px !important;">ข้อมูลส่วนตัว</h4>
          <v-text-field
            label="ชื่อ"
            v-model="name"
            :rules="nameRules"
            single-line
            solo
            :style="'width: 100% !important; color: ' + backgroundText + ' !important;'"
            @keyup.enter="setlogin('otp')"
          ></v-text-field>
          <v-text-field
            label="นามสกุล"
            v-model="lastname"
            :rules="lastnameRules"
            required
            single-line
            solo
            :style="'width: 100% !important; color: ' + backgroundText + ' !important;'"
            @keyup.enter="setlogin('otp')"
          ></v-text-field>
         <!--  <v-text-field
            label="อีเมล"
            v-model="email"
            :rules="emailRules"
            required
            single-line
            solo
            :style="'width: 100% !important; color: ' + backgroundText + ' !important;'"
            @keyup.enter="setlogin('otp')"
          ></v-text-field> -->
          <v-text-field
            label="หมายเลขโทรศัพท์"
            v-model="phone"
            mask="###-###-####"
            pattern="\d*"
            :rules="phoneRules"
            required
            single-line
            solo
            :style="'width: 100% !important; color: ' + backgroundText + ' !important;'"
            @keyup.enter="setlogin('otp')"
          ></v-text-field>
         <!--  <v-text-field
            label="ข้อความเริ่มการสนทนา"
            v-model="textcomment"
            :rules="textcommentRules"
            required
            single-line
            solo
            :style="'width: 100% !important; color: ' + backgroundText + ' !important;'"
            @keyup.enter="setlogin('otp')"
            ></v-text-field> -->
            <v-layout row wrap align-center justify-center >
              <v-btn dark :style="'background-color: ' + backgroundText + ' !important; width: 100%; border-radius: 7px;'" @click="setlogin('otp')" :loading="loading" :disabled="!valid">เริ่มการแชท</v-btn>
            </v-layout>
        </v-form>



        <div v-else-if="typelogin== 'otp'" style="width: 100%; padding: 16px 0px;">
             <h4>ยืนยันรหัส OTP</h4>
  <p style="margin-top: 20px;margin-bottom: 20px;">เบอร์โทร: {{phone}}</p>
   <p style="margin-top: 20px;margin-bottom: 20px; color: #8c8c8c;" v-if="refcode">Refcode: {{refcode}}</p>

    <v-layout row wrap style="overflow: hidden !important; width: 100%;">
  <v-flex xs8>
  <v-text-field
      label="OTP"
      v-model="OTP"
      pattern="\d*"
      required
      single-line
      hide-details
      maxlength="6"
      style="width: 100% !important; margin-top: 10px;margin-bottom: 10px;"
    ></v-text-field>
  </v-flex>
  <v-flex xs4>
    <v-btn depressed  class="btn_otp" style=" margin-top: 10px !important;" :disabled="counting" @click="startCountdown">
        <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
        <template slot-scope="props">{{ props.totalSeconds }} วินาที </template>
      </countdown>
      <span v-if="!counting">ส่ง OTP </span>
    </v-btn>
  </v-flex>
  <span v-if="count_wrongOTP >= 5" style="color: red;">* คุณใส่ OTP ผิดมากกว่า 5 ครั้ง กรุณารอ <span id="time"></span> นาทีเพื่อใส่ OTP ที่ถูกต้อง</span>
</v-layout>
<br>
    <br>
    <div style="margin-top: 5px;text-align: center;">
    <v-btn depressed  class="btn_back" @click="setlogin(''); type_otp='';" :disabled="count_wrongOTP >= 5">ย้อนกลับ</v-btn>
    <v-btn depressed  class="btn_login" @click="login()" :disabled="OTP=='' || count_wrongOTP >= 5" v-if="!progress && type_otp == 'register'">ยืนยัน</v-btn>
    <v-btn depressed  class="btn_login" @click="login()" :disabled="OTP=='' || count_wrongOTP >= 5" v-else-if="!progress && type_otp != 'register'">ยืนยัน</v-btn>
    <v-btn depressed class="btn_login" disabled v-else>
      <v-progress-circular  :size="10" :width="2" indeterminate color="blue"></v-progress-circular>&nbsp; ถัดไป
    </v-btn>
  </div>
  </div>












      </v-layout>
    </div>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
  import Vue from 'vue'
import { sync } from 'vuex-pathify'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { Encode } from '@/services'
const theme = require('../assets/theme')
Vue.component(VueCountdown.name, VueCountdown)

export default {
  data: () => ({
    theme,
    one_id: '',
    ref_otp: '',
    refcode: '',
    type_otp: '',
    OTP: '',
    typelogin: '',
    backgroundText: '',
    colortext: '',
    servicename: '',
    valid: false,
    subject: '',
    name: '',
    lastname: '',
    email: '',
    phone: '',
    textcomment: '',
    account_username: '',
    loading: false,
    progress: false,
    counting: false,
    tokenservice: '',
    Bearer: '',
    headers: '',
    body: '',
    message: '',
    room: '',
    tokenuser: '',
    count_wrongOTP: 0,
    Interval_otpwrong: '',
    minutesCount: 3,
    // keyservice: '',
    phoneRules: [
      v => (!!v && v.length === 10) || 'กรุณากรอกตัวเลขให้ครบ 10 หลัก',
      v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
      v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
    ],
    nameRules: [
      v => !!v || 'กรุณากรอกชื่อ'
    ],
    lastnameRules: [
      v => !!v || 'กรุณากรอกนามสกุล'
    ],
    emailRules: [
      v => !!v || 'กรุณากรอกอีเมล',
      v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมลไม่ถูกต้อง'
    ],
    subjectRules: [
      v => !!v || 'กรุณากรอกหัวข้อปัญหา'
    ],
    textcommentRules: [
      v => !!v || 'กรุณากรอกข้อความเริ่มการสนทนา'
    ]
  }),
  computed: {
    ...sync('*')
  },
  methods: {
    toPage () {
      this.$router.push('/continue/' + this.$route.params.servicename + '/' + this.$route.params.key)
    },
    startCountdown () {
      this.refcode = ''
      this.counting = true
      this.axios.post(process.env.APImanageOTP + '/v2/otp_login_and_regis', { phone: this.phone }, this.headers).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.ref_otp = response.data.mobile_ref_id
          this.refcode = response.data.refcode
          this.type_otp = response.data.type_otp
          this.counting = true
        } else {
          // alert error
          // console.log('test')
          this.counting = false
          this.typelogin = ''
          this.$swal({
            text: 'กรุณาลองใหม่ภายหลัง',
            type: 'warning'
          })
        }
      })
    },
    handleCountdownEnd () {
      this.OTP = ''
      this.counting = false
      this.refcode = ''
    },
    setlogin (type) {
      this.typelogin = type
      console.log(this.typelogin)
      if (this.typelogin === '') {
        this.handleCountdownEnd()
      } else if (this.typelogin === 'otp') {
        this.startCountdown()
      }
    },
    login () {
      // login
      this.headers = {headers: {'Authorization': this.tokenservice}}
      var source = {}
      if (this.typelogin === 'otp') {
        // var source = Encode.encode({ phone: this.phone, type: this.typelogin, password: this.otp, ref: this.ref_otp})
        if (this.type_otp === 'register') {
          source = { phone: this.phone, type: this.typelogin, otp: this.OTP, mobile_ref_id: this.ref_otp, type_otp: this.type_otp, consent_status: 'Y' }
        } else {
          source = { phone: this.phone, type: this.typelogin, otp: this.OTP, mobile_ref_id: this.ref_otp, type_otp: this.type_otp }
        }
      } else {
        source = { phone: this.phone, type: this.typelogin, password: this.password, mobile_ref_id: this.ref_otp, type_otp: this.type_otp }
      }
      this.progress = true
      this.axios.post(process.env.APImanageOTP + '/v2/login_and_regis', source, this.headers).then((response) => {
        // this.progress = false
        if (response.data.status === 'success') {
          if (this.type_otp !== 'select accounts') {
            console.log('openchat')
            // localStorage.setItem('oneid', response.data.account.profile.one_id)
            this.one_id = response.data.account.profile.one_id
            // console.log(response.data.account)
            // console.log(this.one_id)
            // this.$router.push('/m_chat/' + this.servicename + '/chatbot')
            // localStorage.room = response.data.tokenroom
            // localStorage.account_username = response.data.account.profile.tokenuser
            localStorage.tokenuser = response.data.account.profile.tokenuser
            this.tokenuser = localStorage.tokenuser
            // this.room = localStorage.room
            // this.account_username = localStorage.account_username
            // this.tokenuser = localStorage.tokenuser
            this.updateProfile()
            this.checkauthen()
          } else {
            // show state select account and set account
            this.progress = false
            // console.log('listaccount')
            this.ListAccount = response.data.list_accounts
            this.dialogSelectAccount = true
          }
        } else {
          // alert error
          this.progress = false
          if (this.typelogin === 'otp') {
            this.$swal({
              text: 'otp ไม่ถูกต้อง',
              type: 'warning'
            })
            this.count_wrongOTP = this.count_wrongOTP + 1
            if(this.count_wrongOTP >= 5) {
              this.startTimer_count_wrongOTP(60 * this.minutesCount)
            }
          } else if (this.typelogin === 'password') {
            this.$swal({
              text: 'รหัสผ่าน ไม่ถูกต้อง',
              type: 'warning'
            })
          }
        }
      })
    },
    checkauthen () {
      this.body = {one_id: this.one_id, bot_id: this.bot_id}
      this.axios.post(process.env.APImanage + '/getdetailroom', this.body, this.headers).then((response) => {
        // console.log(response.data)
        // console.log(response.data.account)
        // console.log(response.data.bot_profile)
        // this.profilepicturebot = response.data.bot_profile.profilepicture
        // this.botname = response.data.bot_profile.name
        localStorage.room = response.data.tokenroom
        localStorage.account_username = response.data.account.profile.tokenuser
        localStorage.tokenuser = response.data.account.profile.tokenuser


        this.room = localStorage.room
        // this.room = response.data.tokenroom
        // this.name = response.data.account.profile.nickname
        // this.phone = response.data.account.profile.phone
        // this.account_username = response.data.account.profile.username
        this.account_username = localStorage.account_username
        // localStorage.setItem('tokenuser', Encode.encodeAuthen(response.data.account.profile.tokenuser))
        // this.tokenuser = response.data.account.profile.tokenuser
        this.tokenuser = localStorage.tokenuser
        this.redirectToChat()
        // this.Checkconsent()
        // this.getMessageFirst('')
      }, (error) => {
        localStorage.clear()
        this.$router.push('/m_chat/' + this.servicename + '/first')
        console.log(error)
      })
    },
    startTimer_count_wrongOTP(duration) {
      var timer = duration, minutes, seconds;
      var me = this
      // var display = $('#time');
      // console.log(display)
      this.Interval_otpwrong = setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        // console.log(minutes + ":" + seconds)
        // display.textContent = minutes + ":" + seconds;
        document.getElementById("time").innerHTML = minutes + ":" + seconds;
        if (minutes == 0 && seconds == 0) {
          // console.log('momo' + me.count_wrongOTP)
          me.count_wrongOTP = 0
          me.OTP = ''
          clearInterval(me.Interval_otpwrong)
        }

        if (--timer < 0) {
            timer = duration;
        }
      }, 1000);
    },
    redirectToChat () {
      // this.updateProfile()
      var link = process.env.APIredirect + '?user_id=' + Encode.encodeAuthen(this.tokenuser) + '&room_id=' + this.room + '&stateusername=' + (this.account_username? 'true':'false')
      window.open(link, '_self')
      this.progress = false
    },
    login3 () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.headers = {headers: {'Authorization': this.tokenservice}}
        this.body = {email: this.email, nickname: this.name, phone: this.phone, subject: this.subject}
        // console.log(process.env.APImanage + '/create_guest', this.body, this.headers)
        this.axios.post(process.env.APImanage + '/create_guest', this.body, this.headers).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            // console.log(response.data)
            this.loading = false
            this.message = {user_id: response.data.data.tokenuser, to: response.data.data.tokenroom, type: 'text', message: this.textcomment}
            this.axios.post(process.env.APImanage + '/push_message', this.message, this.headers).then((responsed) => {
              // console.log(responsed.data)
              // localStorage.setItem('nickname', this.name)
              // localStorage.setItem('subject', this.subject)
              // localStorage.setItem('tokenroom', response.data.data.tokenroom)
              // localStorage.setItem('tokenuser', response.data.data.tokenuser)
              // localStorage.setItem('servicename', response.data.data.service_name)
              // localStorage.setItem('con_code', response.data.data.con_code)
              // localStorage.setItem('status_login', 'T')
              // localStorage.setItem('status_ticket', 'Open')
              this.myname = this.name
              this.mysubject = this.subject
              this.mytokenroom = response.data.data.tokenroom
              this.mytokenuser = response.data.data.tokenuser
              this.myservicename = response.data.data.service_name
              this.myconcode = response.data.data.con_code
              this.mystatusticket = 'Open'
              this.mystatuslogin = 'T'
              var servicename = response.data.data.service_name
              var concode = response.data.data.con_code
              this.$router.push('/chat/' + servicename + '/' + concode + '/' + response.data.data.tokenroom)
            })
          } else {
            this.mystatuslogin = 'F'
            this.$router.push('/register')
            // console.log(response.data)
          }
        })
      }
    },
    updateProfile() {
      var body = {
            tokenuser: this.tokenuser,
            account_title_th: '',
            first_name_th: this.name,
            last_name_th: this.lastname,
            account_title_eng: '',
            first_name_eng: '',
            last_name_eng: '',
            id_card_type: '',
            id_card_num: '',
            birth_date: ''
      }
      // console.log(body)
      this.axios.post(process.env.APIupdate + '/updateprofile', body).then((response) => {
        // console.log('response', response)
      })
      .catch((err)=>{
        // console.log(err)
      })
    }
  },
  created () {
    if (this.$route.query.from == 'logout') {
      localStorage.clear()
    }
    if(localStorage.room && localStorage.account_username && localStorage.tokenuser){
      this.room = localStorage.room
      this.account_username = localStorage.account_username
      this.tokenuser = localStorage.tokenuser
      this.redirectToChat()
    }
    this.servicename = this.$route.params.servicename
    this.one_id = localStorage.getItem('oneid')
    // console.log(this.one_id)
    if (this.one_id !== null && this.one_id !== undefined && this.one_id !== 'undefined') {
      // this.$router.push('/chat/' + this.servicename + '/chatbot')
      this.checkauthen()
    }
    this.tokenservice = 'Bearer ' + this.theme[this.servicename].authen
    this.image_logo = this.BASE_URL + this.theme[this.servicename].image_logo
    this.style_logo = this.theme[this.servicename].styleLogo
    if (this.theme[this.servicename].image_powerby) {
      this.image_powerby = this.BASE_URL + this.theme[this.servicename].image_powerby
    }
    this.headers = {headers: {'Authorization': this.tokenservice}}
    this.bot_id = this.theme[this.servicename].bot_id
    // console.log('bot id :' ,this.bot_id)
    // console.log('header :' , this.headers )



    this.status_login = this.statuslogin
    // this.tokenservice = 'Bearer ' + 'this.$route.params.key'
    this.$session.set('tokenservice', this.tokenservice)
    // var servicename = this.$route.params.servicename
    // var concode = this.myconcode
    // var tokenroom = this.mytokenroom
    // if (this.status_login === 'T' && concode !== null && tokenroom !== null) {
    //   this.$router.push('/chat/' + servicename + '/' + concode + '/' + tokenroom)
    // }
    // if (this.theme[servicename].authen === this.$route.params.key) {
    //   this.backgroundText = this.theme[servicename].background
    //   this.colortext = this.theme[servicename].background
    // } else {
      this.backgroundText = '#5ca1bf'
      this.colortext = '#01579b'
    // }
    // if(localStorage.room && localStorage.account_username && localStorage.tokenuser){
    //   this.redirectToChat()
    // }
  }
}
</script>

<style lang="css" scoped>
>>>.v-input .input {
  max-height: 27px !important;
}
>>>.v-messages {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  font-size: 12px;
  /*min-height: 12px; */
  min-width: 1px;
  position: relative;
}
>>>.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}
>>>.v-text-field.v-text-field--solo .v-input__control {
  min-height: 24px;
}
>>>.v-input__slot {
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 8px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
a {
  color: #01579b;
}
a:hover {
  color: #01579b;
  text-decoration: underline;
}
.setHeightChatBoxRegis {
  height: calc(100vh - 55px);
  max-height: calc(100vh - 55px);
  /*overflow-y: scroll;*/
}
.setBgHeaderRegis {
  background-color: #01579B;
  height: 30px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.chatBoxFriendRegis {
  word-wrap: break-word;
  max-width: 50%;
  border-radius: 25px;
  background: #E0E0E0;
  padding: 12px;
}
.chatBoxRegis {
  word-wrap: break-word;
  max-width: 50%;
  border-radius: 25px;
  background: #B3E5FC;
  color: black;
  padding: 12px;
}

textarea:focus{
  outline: none !important;
  box-sizing: border-box !important;
  resize: none;
}
.textBoxRegis {
  height: 90px !important;
  border-style: solid solid solid solid !important;
  border-width: 1px;
  border-radius: 7px;
  border-color: #ccc !important;
}

.colorFooterMenuRegis {
  color: #424242
}
input[type=text], select {
    width: 100%;
    padding: 8px 10px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 7px;
    box-sizing: border-box;
}

input[type=submit] {
    width: 100%;
    background-color: #4CAF50;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

input[type=submit]:hover {
    background-color: #45a049;
}

/*div {
    border-radius: 5px;
    background-color: #f2f2f2;
    padding: 20px;
}*/





.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.chat_othercontact {
  text-align: left;
  border-radius: 20px;
  background: #E0E0E0;
  color: black;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size:13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  width: 195px;
}
.chat_selfcontact {
  text-align: left !important;
  border-radius: 20px !important;
  padding: 10px !important;
  font-weight: 300 !important;
  color: black !important;
  font-size:13px !important;
  position: relative !important;
  word-wrap: break-word !important;
  float: right !important;
  width: 195px !important;
}
.chat_othersticker {
  float: left;
  width: 140px;
  height: auto;
}
.chat_selfsticker {
  float: right;
  width: 140px;
  height: auto;
}
.chatBoxvideo_user {
  width: 180px !important;
  height: 225px !important;
  border-radius: 25px !important;
  padding: 12px !important;
  float: right !important;
  text-align: left !important;
  word-wrap: break-word !important;
}
.chatBoxvideo_admin {
  background: #E0E0E0 !important;
  width: 180px !important;
  height: 225px !important;
  border-radius: 25px !important;
  padding: 12px !important;
  float: left !important;
  text-align: left !important;
  word-wrap: break-word !important;
}
.chatBoxfile_user {
  width: 180px !important;
  height: 180px !important;
  border-radius: 25px !important;
  padding: 12px !important;
  float: right !important;
  text-align: left !important;
  word-wrap: break-word !important;
}
.chatBoxfile_admin {
  background: #E0E0E0 !important;
  width: 180px !important;
  height: 180px !important;
  border-radius: 25px !important;
  padding: 12px !important;
  float: left !important;
  text-align: left !important;
  word-wrap: break-word !important;
}
.text2 {
  white-space: nowrap;
  width: 150px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px !important;
  color: black !important;
}
.textfile {
  width: 80px !important;
  height: 100px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  font-size: 12px !important;
  color: black !important;
}
a:link {
  color: #1976d2;
  text-decoration: none;
}

/* visited link */
a:visited {
  color: #1976d2;
  text-decoration: none;
}

/* mouse over link */
a:hover {
  text-decoration: underline;
  color: #1976d2;
}

/* selected link */
a:active {
  color: #1976d2;
}
.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}
.conversation-start span {
  /*font-size: 10px;
  display: inline-block;
  color: #999;*/
  border-style: solid;
  font-size: 10px;
  display: inline-block;
  color: #424242;
  border-width: thin;
  border-radius: 10px;
  width: 80px;
}
.conversation-start span:before, .conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 120px;
  height: 1px;
  content: '';
  /*background-color: #e6e6e6;*/
}
.conversation-start span:before {
  left: 0;
}
.conversation-start span:after {
  right: 0;
}
/*.textfile {
  padding-top: 15px;
  white-space: nowrap;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}*/
.iconfile {
  color: black;
  font-size: 80px !important;
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}
.imageChat {
  /*word-wrap: break-word;
  border-radius: 10px;
  justify-content: center;
  max-height: 150px;
  max-width: 150px;
  cursor: pointer;*/
  border-radius: 10px;
  -ms-flex-pack: center;
  justify-content: center;
  height: 120px;
  width: 155px;
}
.headername {
  height: 50px;
  margin-top: -10px;
  border-bottom-style: solid;
  background: rgb(243, 241, 241);
  border-bottom-width: thin;
  border-bottom-color: #80808047;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 10px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.setHeightChatBox {
  height: calc(100vh - 160px);
  max-height: calc(100vh - 160px);
  /*overflow-y: scroll;*/
  padding-top: 5px;
  overflow-x: hidden;
  background: white;
}
.setBgHeader {
  background-color: #01579B;
  height: 30px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.chatBoxFriend {
  word-wrap: break-word;
  /*max-width: 50%;*/
  max-width: 175px;
  border-radius: 25px;
  background: #E0E0E0;
  padding: 12px;
}
.chatBox {
  word-wrap: break-word;
  max-width: 175px;
  /*max-width: 50%; */
  border-radius: 25px;
  padding: 12px;
}

textarea:focus{
  outline: none !important;
  box-sizing: border-box !important;
  resize: none;
}
.textBox{
  height: 50px;
  border-style: solid solid solid solid !important;
  border-width: 1px;
  border-radius: 7px;
  border-color: rgb(101,101,101);
}
.texboxdisabled {
  background-color: #d5d5d5;
  height: 50px;
  border-style: solid solid solid solid !important;
  border-width: 1px;
  border-radius: 7px;
  border-color: rgb(182, 182, 182);
}
.textname {
  padding-left: 5px;
  color: gray;
  font-size: 12px;
  white-space: nowrap;
  width: 5em;
  overflow: hidden;
  text-overflow: ellipsis;
}
.colorFooterMenu {
  color: #424242;
  font-size: 12px;
  padding-left: 5px;
  /*color: gray;
  font-size: 12px;
  white-space: nowrap;
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;*/
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.user-photoprofilechat{
  background-color: white;
  width: 35px !important;
  height: 35px !important;
  border-radius: 50%;
  overflow: hidden;
  margin: 5px;
}
/* The Modal (background) */
.modalc {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  /*overflow: auto;  Enable scroll if needed */
 /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
  /*background-color: white;*/
}
/* Modal Content (Image) */
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  width: 80%;
  width: auto;
  height: 70vh;
}
/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}
#headcaption {
  margin: auto;
  display: block;
  /*width: 80%;*/
  /*max-width: 100vw;*/
  text-align: left;
  color: white;
  /*padding-left: 15vw ;*/
  padding-top: 1vh;
  padding-bottom: 1vh;
  /*background-color: white;*/
  /*background-color: #1b232d;*/
  /*height: 150px;*/
}
/* Add Animation - Zoom in the Modal */
/*.modal-contentc {
    animation-name: zoom;
    animation-duration: 0.6s;
}*/
@keyframes zoom {
    from {transform:scale(0)}
    to {transform:scale(1)}
}
/* The Close Button */
.close {
    position: absolute;
    top: 0vh;
    right: 35px;
    color: white;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}
.close:hover,
.close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}
/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
    .modal-contentc {
        /*width: 100vw;*/
    }
}
.wrapper {
  position: relative;
  /*display: inline-block;*/
}

>>>.v-tabs__container {
  display: none !important;
  height: 0px !important;
}
.btn_back {
  background: #66808c !important;
  color: white !important;
  border-radius: 20px;
}

.btn_login {
  background: #5ca1bf !important;
  color: white !important;
  border-radius: 20px;
}

.btn_otp {
  background: #5ca1bf !important;
  color: white !important;
  border-radius: 20px;
}

.add-button {
  position: absolute;
  top: 1px;
  left: 1px;
}

.save-to-home-screen-container.ios-container {
    -ms-flex-align: end;
    align-items: flex-end;
}

.save-to-home-screen-container.android-container {
    align-items: flex-start;
    justify-content: flex-end;
}
.overlay.overlay-visible {
    visibility: visible;
    height: 100%;
    opacity: 1;
}
.overlay {
    background: #222;
    background: rgba(30,30,30,0.9);
    visibility: hidden;
    left: 0;
    overflow: scroll;
    position: fixed;
    top: 0;
    width: 100%;
    height: 0;
    z-index: 10000;
    opacity: 0;
    -webkit-transition: 0.07s ease-in;
    transition: 0.07s ease-in;
    -webkit-transition-property: visibility, opacity;
    transition-property: visibility, opacity;
}
.save-to-home-screen-container {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    background: rgba(30,30,30,0.6);
}

.save-to-home-screen-container .lightbox {
    padding: 24px;
    margin: 20px;
    position: relative;
    width: auto;
    max-width: 400px;
}

.overlay-visible .lightbox {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
    visibility: visible;
    opacity: 1;
    height: 171px;
}

.save-to-home-screen-container .share-icon {
    color: #2562af;
    width: 14px;
    height: 14px;
    margin: 0 4px;
}

.lightbox {
    margin: 20px auto;
    width: 520px;
    padding: 50px 100px;
    background: #fff;
    border-radius: 10px;
    -webkit-box-shadow: 0 0 10px rgba(0,0,0,0.5);
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
    visibility: hidden;
    opacity: 0;
    -webkit-transform: translateY(10px);
    -ms-transform: translateY(10px);
    transform: translateY(10px);
    -webkit-transition: all 0.1s ease-in;
    transition: all 0.1s ease-in;
}

@media only screen and (max-width: 800px)
.overlay a.close {
    margin-top: -15px;
    margin-right: -15px;
}

@media only screen and (max-width: 800px)
.lightbox {
    position: absolute;
    left: 0;
    margin-left: 0;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 20px;
}

.overlay a.close {
    float: right;
    margin-top: -60px;
    margin-right: -110px;
}
a:link, a:visited {
    color: #ea4c89;
    text-decoration: none;
    -webkit-transition: color 200ms ease;
    transition: color 200ms ease;
}
.lightbox .display {
    position: relative;
}

html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td {
    margin: 0;
    padding: 0;
    font-size: 100%;
    vertical-align: baseline;
    border: 0;
    background: transparent;
}

.save-to-home-screen-container.ios-container .lightbox:before {
    content: '';
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    border: solid transparent;
    border-top-color: #fff;
    border-width: 12px;
    top: 100%;
}

.save-to-home-screen-container.android-container .lightbox:before {
    content: none;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    border: solid transparent;
    border-top-color: #fff;
    border-width: 12px;
    top: 100%;
}

.save-to-home-screen-container .custom-close-icon {
    position: absolute;
    top: -14px;
    right: -14px;
}

a:link, a:visited {
    color: #ea4c89;
    text-decoration: none;
    -webkit-transition: color 200ms ease;
    transition: color 200ms ease;
}

/*.save-to-home-screen-container.ios-container  {
    display: inline-block;
}*/

/*.save-to-home-screen-container.ios-container .show-on-android {
    display: none;
}*/
.save-to-home-screen-container .custom-close-icon .icon {
    width: 18px;
    height: 18px;
    fill: #6e6d7a;
}

>>>.v-text-field .v-label {
    left: 10px !important;
    }
>>>.theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    padding-left: 10px !important;
}
>>>.v-text-field>.v-input__control>.v-input__slot:before {
    border-style: none !important;
    text-decoration: none;
}
>>>.v-text-field>.v-input__control>.v-input__slot:after {
    border-style: none !important;
    text-decoration: none;
}
>>>.v-text-field.v-input--is-focused>.v-input__control>.v-input__slot:after{
    border-style: none !important;
    text-decoration: none;
}
>>>.v-text-field.v-input--is-focused>.v-input__control>.v-input__slot:before{
    border-style: none !important;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue